import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';

export const StyledTips = styled.div`
  padding: 12px;
  border-radius: 5px;
  background-color: ${th('colors.aliceBlue')};

  @media ${sizes.tabletPortrait} {
    width: 230px;
  }

  @media ${sizes.mediumLargeDesktop} {
    position: absolute;
    right: -250px;
  }

  > ul,
  > p {
    padding-left: 0;
    margin-top: 4px;
    margin-bottom: 0;
    font-size: 14px;
    color: #4c6372bf;

    > li {
      margin: 5px 0 0 20px;
    }
  }
`;
